import React from 'react';
import {Typography} from "@material-ui/core";

export const NoFieldTypeRegistered = () => (
  <Typography>Field Type sin registrar</Typography>
);
